import { render, staticRenderFns } from "./switchProduct.vue?vue&type=template&id=ca756b7e&scoped=true&"
import script from "./switchProduct.vue?vue&type=script&lang=js&"
export * from "./switchProduct.vue?vue&type=script&lang=js&"
import style0 from "./switchProduct.vue?vue&type=style&index=0&id=ca756b7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca756b7e",
  null
  
)

export default component.exports